<div id="main">
  <router-outlet></router-outlet>
</div>

<fgb-footer></fgb-footer>
